import React from 'react';

// Used in table header (e.g., TableEditable.renderHeaderControls) to draw a vertical
// line between groups of toolbar buttons
//
export default function TableHeaderPipeDivider(): JSX.Element {
  return <span className="mediocre-pipeDivider u-mini-spacing-left" />;
}
